import {http} from '../utils'
// 查询
const searchAction = (params) => {
  const url = `/market/management/task/detail`
  return http.post(url, params)
}
// 获取status列表
const getStatus = (id) => {
  const url = `/market/management/task/detail/status/${id}`
  return http.post(url)
}

export default {
  searchAction,
  getStatus,
}
